import { callApi } from '../../libs'

const getBookingForm = async (id) => {
    return new Promise(async (resolve, reject) => {
        const url = `${process.env.REACT_APP_API_COVID19}/api/map-routes/all-data`
        const method = 'post'
        const body = {
            mapRouteID: id
        }
        try {
            const response = await callApi(method, url, body, null)
            resolve(response)
        } catch (error) {
            reject(error)
        }
    })
}

export default getBookingForm